import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Row, Col } from 'reactstrap'
import { Auth } from 'aws-amplify';

import CompleteVerification from './CompleteVerification'

import { isAuthenticated } from '../../../features/session/sessionSlice'
import { useStyles } from '../../styles/LoginStyles'
import { checkUserExists } from '../../utils/Users'
import NonAuthHeader from '../Layout/NonAuthHeader'
import { parseTheme } from '../../utils/common'

const INITIAL_STATE = {
    email: "",
    showForgotPass: true,
    posting: false,
    showVerificationForm: false,
    setting: {},
    formTitle: "Forgot Password"
}

function ForgotPassword(){

    const [state,setState] = useState(INITIAL_STATE)

    const history = useHistory()
    const isAuth = useSelector(isAuthenticated);

    const submitForm = async(e) => {
        e.preventDefault()
        setState(prevState => ({
            ...prevState,
            posting: true
        }))
        const { email } = state

        try {
            const {response, error} = await checkUserExists(email, "FORCE_CHANGE_PASSWORD")

            if(error){
                throw new Error("Unable to process. Please contact the system administrator to address your user login issue")
            }

            if(response.exists && response.canVerify){  
                try {
                    await Auth.forgotPassword(email)
                } catch(e) {
                    toast.error(e.message, {containerId: "forgotPassToastContainer"})
                }          
            } else {
                if(response.exists && !response.canVerify){
                    
                    toast.success("A verification email has been sent to your inbox", {containerId: "forgotPassToastContainer"})
                    
                    setState(prevState => ({
                        ...prevState,
                        posting: false
                    }))
                    setTimeout(()=> {                        
                        history.push("/login")
                    }, 10000)


                    return
                } else if(!response.exists){
                    throw new Error("Email does not exist")
                }
                // throw new Error("Unable to process. Please contact the system administrator to address your user login issue")
            }

            setState(prevState => ({
                ...prevState,
                showVerificationForm: true,
                showForgotPass: false,
                posting: false
            }))

            toast.success("A verification email has been sent to your inbox", {containerId: "forgotPassToastContainer"})
        } catch(e) {
            toast.error(e.message, {containerId: "forgotPassToastContainer"})
        }
    }

    const onCompleteVerificationSubmit = async(formState) => {

        try {
            const { email, $state } = state
            const { verificationCode, password } = formState
            await Auth.forgotPasswordSubmit(email, verificationCode, password)

            toast.success("Password has been changed successfully!", {containerId: "forgotPassToastContainer"})
            setTimeout(() => history.push('/login'), 1250)
        } catch(e) {
            toast.error(e.message, {containerId: "forgotPassToastContainer"})
        }
    }

    const { setting, formTitle, showForgotPass, showVerificationForm, posting } = state
    let logoDir = "images/insights-engine.png"
    
    const theme = parseTheme()

    if(theme && theme.mainLogo){
        logoDir = theme.mainLogo
    }

    const classes = useStyles()

    return <>
        <NonAuthHeader />
        <div class="container container-padded">
            <Row className={classes.container}>
                {!isAuth && <ToastContainer
                    containerId="forgotPassToastContainer"
                    position="top-right"
                    autoClose={6000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                    />}
                <Col xs="12" sm="12" md="8" lg="6" xl="6" className="form mx-auto p-4">
                    <div className="row pt-4">
                        <div className="col"><hr /></div>
                        <div className="col-auto">{formTitle.toUpperCase()}</div>
                        <div className="col"><hr /></div>
                    </div>
                    {showForgotPass && <form onSubmit={(e) => submitForm(e)}>
                        <div className="form-group">
                            <input type="email" onChange={e => setState({ ...state, email: e.target.value.toLowerCase()}) } className="form-control input-lg" placeholder="Email" name="email" required="" />
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-success btn-lg btn-block">
                                {posting && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                Send Verification Email
                            </button>
                        </div>
                    </form>}
                    {showVerificationForm &&<CompleteVerification onSubmit={formState => onCompleteVerificationSubmit(formState)} />}
                    <img className="img-fluid mx-auto d-block mb-3" src={"images/powered-by.png"} style={{maxHeight: "100px"}} />
                    <a className="text-center d-block" href="https://internetstrategylabs.com/privacy-policy/" target="_blank">
                        Privacy Policy
                    </a>
                </Col>
            </Row>
        </div>
    </>
}

export default ForgotPassword